import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Correction } from "../../../Request/DcfRequestReducer";

const PreviewSelector = (corrections: Correction[]): boolean => corrections.length > 0 && corrections[0].entity === "Subject" && corrections[0].field === "SubjectNumber";

const SubjectIdPreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    if (!(PreviewSelector(corrections))) {
        return null;
    }

    return <CorrectionBreakdownItem fieldName={corrections[0].field} from={corrections[0].oldValue} to={corrections[0].newValue} />;
};

const SubjectIdPreview: CorrectionItemPreview = {
    previewElement: SubjectIdPreviewItem,
    previewSelector: PreviewSelector
};

export default SubjectIdPreview;
